import React from "react";
import { Difficulty } from "../../game/usePuzzleStore";

interface DifficultySelectorProps {
  currentDifficulty: Difficulty;
  onSelect: (difficulty: Difficulty) => void;
  disabled?: boolean;
}

const DIFFICULTY_LABELS: Record<Difficulty, string> = {
  easy: "Easy (3×3)",
  medium: "Medium (4×4)",
  hard: "Hard (6×6)"
};

export const DifficultySelector: React.FC<DifficultySelectorProps> = ({
  currentDifficulty,
  onSelect,
  disabled = false
}) => {
  const difficulties: Difficulty[] = ["easy", "medium", "hard"];

  return (
    <div
      className="stack-h stack-h--gap-sm"
      style={{
        alignItems: "center",
        flexWrap: "wrap"
      }}
      role="group"
      aria-label="Difficulty selection"
    >
      <span className="text-xs text-muted" style={{ marginRight: "0.25rem" }}>
        Difficulty:
      </span>
      {difficulties.map((difficulty) => (
        <button
          key={difficulty}
          type="button"
          onClick={() => !disabled && onSelect(difficulty)}
          disabled={disabled}
          className={`btn ${currentDifficulty === difficulty ? "btn--primary" : "btn--ghost"}`}
          style={{
            fontSize: "0.75rem",
            padding: "0.35rem 0.65rem",
            minWidth: "auto"
          }}
          aria-pressed={currentDifficulty === difficulty}
        >
          {DIFFICULTY_LABELS[difficulty]}
        </button>
      ))}
    </div>
  );
};

